import { wrapPromise } from 'persist-promise/wrapPromise';
import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
import { Metrics } from '../metrics';
import { fetchConditionalPropertyRules } from './conditionalPropertyRulesApi';
const makeConditionalPropertyRulesFetchKey = ({
  portalId,
  frameworkTypeIdentifier,
  query
}) => {
  const queryString = query !== null && query !== void 0 && query.includePipelineStageShim ? `?includePipelineStageShim=true` : '';
  return `conditional-property-rules-${portalId || 'current'}-${frameworkTypeIdentifier}${queryString}`;
};
const conditionalPropertyRulesPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'conditionalPropertyRules',
  deepFreeze: true,
  toCacheKey: makeConditionalPropertyRulesFetchKey,
  fetch: ({
    httpClient,
    rpcClient,
    frameworkTypeIdentifier,
    query
  }) => fetchConditionalPropertyRules(frameworkTypeIdentifier, httpClient, rpcClient, query)
});
export const makeConditionalPropertyRulesClient = ({
  httpClient,
  rpcClient,
  persistedPromise = conditionalPropertyRulesPersistedPromise
}) => Promise.resolve({
  debug: () => {
    persistedPromise.debug();
  },
  clearCache: () => {
    persistedPromise.clearCache();
    return Promise.resolve();
  },
  get: ({
    frameworkTypeIdentifier,
    query,
    refetch = false
  }) => {
    Metrics.counter('conditionalPropertyRules.get').increment();
    return persistedPromise.makeFetchWithOpts({
      allowEagerCacheReturn: isEarlyCacheReturnEnabled(),
      refresh: refetch
    })({
      httpClient,
      rpcClient,
      frameworkTypeIdentifier,
      query
    });
  }
});